import { render, staticRenderFns } from "./RiskLevelSelector.vue?vue&type=template&id=5b7b1135&scoped=true&"
import script from "./RiskLevelSelector.vue?vue&type=script&lang=js&"
export * from "./RiskLevelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b1135",
  null
  
)

export default component.exports